jQuery(document).ready(function ($) {
	$('a[href*="#"]')
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function (event) {
			var target = $(this.hash);
			target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");

			if (target.length) {
				event.preventDefault();

				// Zamknij menu offcanvas
				$(".offcanvas").offcanvas("hide");

				if (this.pathname !== location.pathname) {
					window.location.href = this.href;
				} else {
					setTimeout(function () {
						$("html, body").animate(
							{
								scrollTop: target.offset().top,
							},
							1000
						);
					}, 350); // Opóźnienie przewijania, aby menu mogło się zamknąć
				}
			}
		});
});
